(function () {
    const $ = require('jquery');
    const Vue = require('vue').default;

    const attorneysFee = require('./attorneys-fee');
    const deedsOfficeFeeForBond = require('./deeds-office-fee-for-bond');
    const deedsOfficeFeeForTransfer = require('./deeds-office-fee-for-transfer');
    const fmt = require('./format-rands');
    const transferDuty = require('./transfer-duty');

    if ($('#transfer-calculator').length == 0) {
        return;
    }

    const calculator = new Vue({
        el: '#transfer-calculator',
        data: {
            purchasePrice: null,
            bondAmount: null,
        },
        computed: {
            amount: function () {
                if (this.bondAmount) {
                    return this.bondAmount;
                }

                return this.purchasePrice;
            },
            calculatorTitle: function() {
                if (this.purchasePrice && !this.bondAmount) {
                    return 'Your total transfer costs:';
                } else if (!this.purchasePrice && this.bondAmount) {
                    return 'Your total bond costs:';
                } else {
                    return 'Your total transfer & bond costs:';
                }
            },
            deedsOfficeSearchFee: function () {
                return 180;
            },
            fmtDeedsOfficeSearchFee: function () {
                return fmt(this.deedsOfficeSearchFee);
            },
            transferDuty: function () {
                return transferDuty(this.purchasePrice);
            },
            fmtTransferDuty: function () {
                return fmt(this.transferDuty);
            },
            bondCost: function () {
                return this.deedsOfficeFeeForBond
                    + this.attorneysFee
                    + this.postAndPetties
                    + this.electronicFacilitationCost
                    + this.deedsOfficeSearchFee
                    + this.VAT
                    + this.bankInitiationFee
                ;
            },
            fmtBondCost: function () {
                return fmt(this.bondCost);
            },
            deedsOfficeFeeForBond: function () {
                return deedsOfficeFeeForBond(this.bondAmount);
            },
            fmtDeedsOfficeFeeForBond: function () {
                return fmt(this.deedsOfficeFeeForBond);
            },
            deedsOfficeFeeForTransfer: function () {
                return deedsOfficeFeeForTransfer(this.purchasePrice);
            },
            fmtDeedsOfficeFeeForTransfer: function () {
                return fmt(this.deedsOfficeFeeForTransfer);
            },
            attorneysFeeForBond: function () {
                return attorneysFee(this.bondAmount);
            },
            fmtAttorneysFeeForBond: function () {
                return fmt(this.attorneysFeeForBond);
            },
            attorneysFeeForTransfer: function () {
                return attorneysFee(this.purchasePrice);
            },
            fmtAttorneysFeeForTransfer: function () {
                return fmt(this.attorneysFeeForTransfer);
            },
            postAndPetties: function () {
                return 1100;
            },
            fmtPostAndPetties: function () {
                return fmt(this.postAndPetties);
            },
            electronicFacilitationCost: function () {
                return 195;
            },
            fmtElectronicFacilitationCost: function () {
                return fmt(this.electronicFacilitationCost);
            },
            VATForTransfer: function () {
                return (
                    this.attorneysFeeForTransfer
                    + this.postAndPetties
                    + this.electronicFacilitationCost
                    + this.deedsOfficeSearchFee
                ) * 0.15;
            },
            fmtVATForTransfer: function () {
                return fmt(this.VATForTransfer);
            },
            VATForBond: function () {
                return (this.attorneysFeeForBond + this.postAndPetties + this.electronicFacilitationCost + this.deedsOfficeSearchFee) * 0.15;
            },
            fmtVATForBond: function () {
                return fmt(this.VATForBond);
            },
            initiationFee: function () {
                return 6037.50;
            },
            fmtInitiationFee: function () {
                return fmt(this.initiationFee);
            },
            totalBondCost: function () {
                if (!this.bondAmount) {
                    return 0;
                }

                return this.deedsOfficeFeeForBond
                    + this.attorneysFeeForBond
                    + this.postAndPetties
                    + this.electronicFacilitationCost
                    + this.deedsOfficeSearchFee
                    + this.VATForBond
                    + this.initiationFee
                ;
            },
            fmtTotalBondCost: function () {
                return fmt(this.totalBondCost);
            },
            totalTransferCost: function () {
                if (!this.purchasePrice) {
                    return 0;
                }

                return this.transferDuty
                    + this.deedsOfficeFeeForTransfer
                    + this.attorneysFeeForTransfer
                    + this.postAndPetties
                    + this.electronicFacilitationCost
                    + this.deedsOfficeSearchFee
                    + this.VATForTransfer
                ;
            },
            fmtTotalTransferCost: function () {
                return fmt(this.totalTransferCost);
            },
            total: function () {
                return this.totalTransferCost + this.totalBondCost;
            },
            fmtTotal: function () {
                return fmt(this.total);
            },
        },
    });
})();
